import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { Box } from 'foundations-components/transitional/components/Box';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import TrackedZeroState from './zero-states/TrackedZeroState';
import RequestAccessToInboxContainer from '../../access-control/components/RequestAccessToInboxContainer';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class MissingPermission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPromptOpen: false
    };
    this.closeRequestAccessPrompt = this.closeRequestAccessPrompt.bind(this);
    this.openRequestAccessPrompt = this.openRequestAccessPrompt.bind(this);
  }
  openRequestAccessPrompt() {
    this.setState({
      isPromptOpen: true
    });
  }
  closeRequestAccessPrompt() {
    this.setState({
      isPromptOpen: false
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "MISSING_PERMISSION_SUCCESS"
      }), /*#__PURE__*/_jsxs(Flex, {
        inlineSize: "370px",
        marginBlockStart: "1500",
        marginInline: "auto",
        justifyContent: "start",
        alignItems: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "keys",
            width: "100px"
          })
        }), /*#__PURE__*/_jsx(Box, {
          marginBlockStart: "600",
          children: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.missing-permissions.title"
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.missing-permissions.firstBody"
            })
          })
        }, 1), /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: this.openRequestAccessPrompt,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.missing-permissions.button"
          })
        })]
      }), this.state.isPromptOpen ? /*#__PURE__*/_jsx(RequestAccessToInboxContainer, {
        onReject: this.closeRequestAccessPrompt,
        onConfirm: this.closeRequestAccessPrompt
      }) : null]
    });
  }
}
MissingPermission.displayName = 'MissingPermission';
export default TrackedZeroState({
  zeroStateName: 'MissingPermission'
})(MissingPermission);